/**
 * Conversation modes — the surfaces a conversation can run as, always derived from the URL
 * (never persisted). Owned by the Conversation slice; mirrors the backend's ConversationMode,
 * kept coarse (the backend's TEACHER_TOOLS_* sub-modes all map to 'teacher-tools' here).
 *
 * PRACTICE_LAUNCH has no backend counterpart: it is the short-lived launcher route a study chat
 * card opens in a new tab (TANAI-2622). It exists so that route is never taken for study mode,
 * which would restore and write the study tabs' shared state.
 */
export const CONVERSATION_MODES = Object.freeze({
  STUDY: 'study',
  PRACTICE: 'practice',
  REVISION: 'revision',
  TEACHER_TOOLS: 'teacher-tools',
  PRACTICE_LAUNCH: 'practice-launch',
} as const);

export type ConversationMode = (typeof CONVERSATION_MODES)[keyof typeof CONVERSATION_MODES];
